import script from "./DetailSeccionSpecial.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailSeccionSpecial.vue?vue&type=script&lang=ts&setup=true"

import "./DetailSeccionSpecial.vue?vue&type=style&index=0&id=121d3ecc&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121d3ecc"]])

export default __exports__